export const dataStore = {
	state: {
		formFields: {
			cdiLocationID: {val: 0, qsField: '[cdi_location_id]'},
			orderBy: { val: '', qsField: '[orderby]'},
			direction: {val: '', qsField: '[direction]'}
		},
		data: {},
	}
}